import { useCallback, useEffect, useState } from 'react';

/**
 * URL `blob:` di un contenuto scaricato, con il suo ciclo di vita: `show(blob)` lo crea, `show(null)`
 * lo rilascia; ogni URL sostituito o rimasto all'uscita del componente è revocato
 * (`URL.revokeObjectURL`), così il contenuto non resta in memoria dopo la chiusura del visore.
 */
export function useObjectUrl() {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!url) return undefined;
    return () => URL.revokeObjectURL(url);
  }, [url]);
  const show = useCallback((blob: Blob | null) => setUrl(blob ? URL.createObjectURL(blob) : null), []);
  return [url, show] as const;
}
